export type FETCH_CONFIGURATION_SUCCESS =
  "configuration.FETCH_CONFIGURATION_SUCCESS";
export const FETCH_CONFIGURATION_SUCCESS: FETCH_CONFIGURATION_SUCCESS =
  "configuration.FETCH_CONFIGURATION_SUCCESS";

export type FETCH_CONFIGURATION_FAILURE =
  "configuration.FETCH_CONFIGURATION_FAILURE";
export const FETCH_CONFIGURATION_FAILURE: FETCH_CONFIGURATION_FAILURE =
  "configuration.FETCH_CONFIGURATION_FAILURE";
